module.exports = __webpack_public_path__ + "media/images/store 1-7f518c32.svg";